import Vue from 'vue'
import x5GMaps from 'x5-gmaps'
import { googleMapsApiKey } from '../_config/config'

Vue.use(x5GMaps, { key: googleMapsApiKey, libraries: ['places'] })
